import React, { useState, useEffect, useContext } from "react";
import { Select, Input, Form, DatePicker } from "antd";
import useFetch from '../../commons/useFetch'
import EndowModal from "./EndowModal";
import moment from 'moment';
import { Redirect, Link, useHistory} from 'react-router-dom';
import { ContextSearch, ContextDateSearch} from '../../contexts/Search'
function Booking() {
  const { data: hotels } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels');
  const { data: Rooms } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/Rooms/');
  const [endowModal, setEndowModal] = useState(false);
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const dateFormat = 'DD-MM-YYYY';
  var today = new Date();
  var currentDate = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
  const [datePicker, setDatePicker] = useState([currentDate, currentDate]);
  const [hotelsValue, setHotelsValue] = useState(null)
  const history = useHistory();
  const { onSearch } = useContext(ContextSearch);
  const { onDateSearch } = useContext(ContextDateSearch);

  const showModal = () => {
    setEndowModal(true)
  }
  const handleHotels =(value)=>{
    setHotelsValue(value)

  }

  function onChange(value) {
    const startTime = value[0].format(dateFormat);
    const endTime = value[1].format(dateFormat);
    setDatePicker([startTime, endTime]);
  }
  const submit = (event) => {
    event.preventDefault();

    const newHotelsData = [];
    hotels && hotels.map(
      (e) => e.id === hotelsValue && newHotelsData.push(e)
    );
    onSearch(newHotelsData)
    
    const newDateData = [];
    Rooms && Rooms.map(
      (e) => e.hotel_id === hotelsValue
        && moment(e.start_date_empty, "DD-MM-YYYY").unix() <= moment(datePicker[0], "DD-MM-YYYY").unix() 
        && moment(e.end_date_empty, "DD-MM-YYYY").unix() >= moment(datePicker[1], "DD-MM-YYYY").unix()
      && newDateData.push(e)
    );
    
    onDateSearch(newDateData)

    if (newHotelsData.length > 0 && newDateData.length >0) {
      history.push('/booking?step=1')
      localStorage.setItem("dateValue", JSON.stringify(datePicker));
    } else {
      alert('không có phòng được tìm thấy')
    }
  }
  
  return (
    <div className="booking" id="booking">
        <div className="row styleBooking">
          <div className="col-lg-3 col-12">
            <div className="formInput">
              <div className="formLocation">
              <label>Khách sạn</label>
              <Select placeholder="Chọn khách sạn" onChange={handleHotels} name="hotels">
                {hotels && hotels.map((option) => (
                  <Option value={option.id} key={option.id}>{option.name}</Option>
                ))}
              </Select>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-12">
            <div className="formInput date">
              <label>Thời gian</label>
                <RangePicker
                  defaultValue={[moment(datePicker[0], dateFormat), moment(datePicker[1], dateFormat)]}
                  value={[moment(datePicker[0], dateFormat), moment(datePicker[1], dateFormat)]}
                  format={dateFormat}
                  onChange={(value) => onChange([value[0], value[1]])}
                />
            </div>
          </div>
          <div className="col-lg-2 col-12">
            <a onClick={showModal}>Chọn ưu đãi</a>
          </div>
          <div className="col-lg-2 col-12 btnSearch">
            <button  type="submit" onClick={submit}>
            <img src="/images/search.png" alt="" /> Tìm kiếm
            </button>
          </div>
        </div>
      
      <EndowModal endowModal={endowModal} setEndowModal={setEndowModal} />
    </div>
  );
}
export default Booking;
